module.exports = __webpack_public_path__ + "img/eematico-toys-jucarii-caruselul.e3e10361.jpg";